exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    background-color: #F0F0F0;\r\n    display: block;\r\n    /* height: 100px; */\r\n}\r\n.alloc-popup-wrapper {\r\n    padding: 15px;\r\n}\r\n/*\r\n::ng-deep .alloc-popup-wrapper lfwms-result-data-table .lfwms-hdr-checkbox {\r\n    display: none;\r\n}\r\n\r\n::ng-deep .alloc-popup-wrapper lfwms-result-data-table .header-content .icon-sort {\r\n    display: none;\r\n}\r\n\r\n\r\n::ng-deep .alloc-popup-wrapper lfwms-result-data-table .header-content .ag-header-row {\r\n    \r\n}\r\n*/\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-alloc-summary-popup/wave-alloc-summary-popup.component.css
// module id = ../../../../../src/app/shared/lookup/wave-alloc-summary-popup/wave-alloc-summary-popup.component.css
// module chunks = main